import { createReducer, on } from '@ngrx/store';
import { deepEqual } from '../../../shared/utils/deep-equal.util';

import type { User, UserCounts } from '../../models/user';
import {
  checkProjectsExistenceSuccess,
  setAdminUserCounts,
  setCurrentUser,
  setUserCountsSuccess,
  updateUserCounts,
} from './user-info.actions';

export interface State {
  hasProjects: boolean;
  currentUser: User | undefined;
  userCounts: UserCounts;
  adminUserCounts: {
    filtered: number;
    all: number;
  };
}

const initialState: State = {
  hasProjects: false,
  currentUser: undefined,
  userCounts: {
    owned_monitoringitems: 0,
  },
  adminUserCounts: {
    filtered: 0,
    all: 0,
  },
};

export const reducer = createReducer(
  initialState,
  on(checkProjectsExistenceSuccess, (state: State, { hasProjects }) => ({
    ...state,
    hasProjects: hasProjects,
  })),
  on(setCurrentUser, (state: State, { user }) => {
    const oldUser = state.currentUser;
    if (deepEqual(oldUser, user)) {
      return state;
    }
    return {
      ...state,
      currentUser: user,
    };
  }),
  on(setUserCountsSuccess, (state: State, { counts }) => ({
    ...state,
    userCounts: counts,
  })),
  on(setAdminUserCounts, (state: State, { adminUserCounts }) => ({
    ...state,
    adminUserCounts,
  })),
  on(updateUserCounts, (state: State, { countName, countValue }) => ({
    ...state,
    userCounts: {
      ...state.userCounts,
      [countName]: countValue,
    },
  })),
);

export const getHasProjects = (state: State) => state.hasProjects;
export const getCurrentUser = (state: State) => state.currentUser;
export const getUserCounts = (state: State) => state.userCounts;
export const getAdminUserCounts = (state: State) => state.adminUserCounts;
